// import React, { useEffect, useState } from "react";
// import api from "../../../../../api/axios";

// // date formatter - only date (dd/mm/yyyy)
// const formatDate = (iso) => {
//   if (!iso) return "-";
//   try {
//     const d = new Date(iso);
//     if (Number.isNaN(d.getTime())) return iso;
//     return d.toLocaleDateString("en-GB"); // DD/MM/YYYY
//   } catch {
//     return iso;
//   }
// };

// const safeNum = (v) => {
//   const n = Number(v);
//   return Number.isFinite(n) ? n : 0;
// };

// const RoomCheckout = () => {
//   // lists & selected
//   const [checkedInReservations, setCheckedInReservations] = useState([]);
//   const [selectedId, setSelectedId] = useState("");
//   const [reservation, setReservation] = useState(null);

//   // payments, taxes, pos
//   const [payments, setPayments] = useState([]);
//   const [taxDefs, setTaxDefs] = useState([]); // from API
//   const [taxesComputed, setTaxesComputed] = useState([]); // [{id,name,percent,amount}]
//   const [posItems, setPosItems] = useState([]);
//   const [posTotal, setPosTotal] = useState(0);

//   // ui state
//   const [loadingList, setLoadingList] = useState(false);
//   const [loadingReservation, setLoadingReservation] = useState(false);
//   const [loadingPayments, setLoadingPayments] = useState(false);
//   const [loadingPos, setLoadingPos] = useState(false);
//   const [loadingTaxes, setLoadingTaxes] = useState(false);
//   const [error, setError] = useState(null);

//   // payment modal
//   const [showPaymentModal, setShowPaymentModal] = useState(false);
//   const [paymentAmt, setPaymentAmt] = useState("");
//   const [paymentMethod, setPaymentMethod] = useState("");
//   const [paymentRemark, setPaymentRemark] = useState("");
//   const [submittingPayment, setSubmittingPayment] = useState(false);

//   // totals
//   const [roomSubtotal, setRoomSubtotal] = useState(0);
//   const [taxTotal, setTaxTotal] = useState(0);
//   const [paymentsTotal, setPaymentsTotal] = useState(0);
//   const [dueAmount, setDueAmount] = useState(0);

//   // --- Load checked-in reservations + Tax Definitions ---
//   useEffect(() => {
//     const load = async () => {
//       setLoadingList(true);
//       try {
//         const res = await api.get("pms/reservations/checked-in");
//         setCheckedInReservations(
//           Array.isArray(res.data) ? res.data : res.data?.data ?? []
//         );
//       } finally {
//         setLoadingList(false);
//       }
//     };

//     const loadTaxDefs = async () => {
//       setLoadingTaxes(true);
//       try {
//         const res = await api.get("/pms/taxes");
//         const data = Array.isArray(res.data?.data)
//           ? res.data.data
//           : Array.isArray(res.data)
//           ? res.data
//           : [];
//         setTaxDefs(data);
//       } finally {
//         setLoadingTaxes(false);
//       }
//     };

//     load();
//     loadTaxDefs();
//   }, []);

//   // --- TAX CALCULATION FROM API ---
//   useEffect(() => {
//     if (!reservation) return;

//     if (!taxDefs.length) {
//       setTaxesComputed([]);
//       setTaxTotal(0);
//       return;
//     }

//     const cin = new Date(reservation.check_in);
//     const cout = new Date(reservation.check_out);

//     const diff = cout - cin;
//     const nights = Math.max(1, Math.ceil(diff / (1000 * 60 * 60 * 24)));

//     // get base room price (not total)
//     const basePrice = safeNum(reservation?.room?.room_price ?? 0);
//     const ratePrice = safeNum(reservation?.rate_type.base_price ?? 0);
//     const roomBase = (basePrice + ratePrice) * nights;

//     const computed = taxDefs.map((t) => {
//       const pct = safeNum(t.percentage ?? t.percent);
//       const amount = (pct / 100) * roomBase;
//       return {
//         id: t.id,
//         name: t.name,
//         percent: pct,
//         amount,
//       };
//     });

//     setTaxesComputed(computed);

//     const tot = computed.reduce((s, x) => s + safeNum(x.amount), 0);
//     setTaxTotal(tot);
//   }, [taxDefs, roomSubtotal, reservation]);

//   // --- Load POS Pay-Later items ---
//   const loadPos = async (id) => {
//     setLoadingPos(true);
//     try {
//       const res = await api.get(`pms/pos/reservations/${id}`);

//       const sales = Array.isArray(res.data) ? res.data : res.data?.data ?? [];

//       const flatItems = [];
//       let total = 0;

//       sales.forEach((sale) => {
//         if (
//           String(sale.payment_mode).toLowerCase() === "pay later" &&
//           String(sale.status).toLowerCase() === "open"
//         ) {
//           total += safeNum(sale.total);

//           sale.items?.forEach((it) => {
//             flatItems.push({
//               id: it.id,
//               name: it.name,
//               quantity: it.quantity,
//               amount: it.line_total,
//             });
//           });
//         }
//       });

//       setPosItems(flatItems);
//       setPosTotal(total);
//     } catch {
//       setPosItems([]);
//       setPosTotal(0);
//     } finally {
//       setLoadingPos(false);
//     }
//   };

//   // --- when selectedId changes, load reservation + payments + pos ---
//   useEffect(() => {
//     if (!selectedId) {
//       setReservation(null);
//       setPayments([]);
//       setPosItems([]);
//       setTaxesComputed([]);
//       setRoomSubtotal(0);
//       setTaxTotal(0);
//       setPosTotal(0);
//       setPaymentsTotal(0);
//       setDueAmount(0);
//       return;
//     }

//     const loadAll = async (id) => {
//       setLoadingReservation(true);
//       setError(null);

//       try {
//         // reservation
//         const res = await api.get(`pms/reservations/${id}`);
//         const reservationData = res.data?.data ?? null;
//         setReservation(reservationData);

//         // payments
//         setLoadingPayments(true);
//         try {
//           const p = await api.get(`pms/reservations/${id}/payments`);
//           const pData = Array.isArray(p.data)
//             ? p.data
//             : Array.isArray(p.data?.data)
//             ? p.data.data
//             : [];
//           setPayments(pData);
//         } catch {
//           setPayments([]);
//         } finally {
//           setLoadingPayments(false);
//         }

//         // pos
//         await loadPos(id);

//         let computedRoomSubtotal = 0;
//         if (reservationData) {
//           if (
//             reservationData.total !== undefined &&
//             reservationData.total !== null &&
//             !isNaN(Number(reservationData.total))
//           ) {
//             computedRoomSubtotal = Number(reservationData.total);
//           } else {
//             const roomPrice = safeNum(reservationData?.room?.room_price);
//             const ratetypePrice = safeNum(
//               reservationData?.rate_type?.base_price
//             );
//             const nights =
//               safeNum(reservationData?.total_nights) ||
//               (() => {
//                 try {
//                   const cin = reservationData?.check_in
//                     ? new Date(reservationData.check_in)
//                     : null;
//                   const cout = reservationData?.check_out
//                     ? new Date(reservationData.check_out)
//                     : null;
//                   if (
//                     cin &&
//                     cout &&
//                     !isNaN(cin.getTime()) &&
//                     !isNaN(cout.getTime())
//                   ) {
//                     const diffMs = Math.max(0, cout.getTime() - cin.getTime());
//                     const days = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
//                     return days || 1;
//                   }
//                 } catch {}
//                 return 1;
//               })();
//             computedRoomSubtotal = (roomPrice + ratetypePrice) * nights;
//             console.log(roomPrice);
//             console.log(ratetypePrice);
//             console.log(computedRoomSubtotal);
//           }
//         }
//         setRoomSubtotal(computedRoomSubtotal);
//       } catch (err) {
//         setError("Failed to load reservation details");
//         setReservation(null);
//         setPayments([]);
//         setPosItems([]);
//         setTaxesComputed([]);
//       } finally {
//         setLoadingReservation(false);
//       }
//     };

//     loadAll(selectedId);
//   }, [selectedId]);

//   // --- recompute totals whenever payments, taxesComputed, posItems or roomSubtotal change ---
//   useEffect(() => {
//     const pTotal = (Array.isArray(payments) ? payments : []).reduce(
//       (s, x) => s + safeNum(x.amount ?? x.amt ?? x.value),
//       0
//     );
//     const tTotal = (Array.isArray(taxesComputed) ? taxesComputed : []).reduce(
//       (s, x) => s + safeNum(x.amount),
//       0
//     );
//     const posT = safeNum(posTotal);

//     setPaymentsTotal(pTotal);
//     setTaxTotal(tTotal);

//     const due = safeNum(roomSubtotal) + tTotal + posT - pTotal;
//     setDueAmount(Number(due.toFixed(2)));
//   }, [payments, taxesComputed, posTotal, roomSubtotal]);

//   const calculateNights = (checkIn, checkOut) => {
//     if (!checkIn || !checkOut) return 0;
//     const d1 = new Date(checkIn);
//     const d2 = new Date(checkOut);

//     const diff = d2.getTime() - d1.getTime();
//     return Math.ceil(diff / (1000 * 60 * 60 * 24));
//   };

//   const calculateRoomSubtotal = (roomPrice, ratePrice, nights) => {
//     const r1 = Number(roomPrice) || 0;
//     const r2 = Number(ratePrice) || 0;
//     return (r1 + r2) * nights;
//   };
//   // --- payment submit ---
//   const submitPayment = async () => {
//     if (!selectedId) {
//       alert("Select a reservation first");
//       return;
//     }
//     if (!paymentAmt || Number(paymentAmt) <= 0) {
//       alert("Enter valid payment amount");
//       return;
//     }
//     if (!paymentMethod) {
//       alert("Choose a payment method");
//       return;
//     }

//     setSubmittingPayment(true);
//     try {
//       await api.post(`pms/reservations/${selectedId}/payments`, {
//         amount: Number(paymentAmt),
//         mode: paymentMethod,
//         remarks: paymentRemark,
//       });

//       // After payment created, re-fetch payments + reservation + pos + taxes (best effort)
//       try {
//         const [resRes, payRes, posRes, taxesRes] = await Promise.allSettled([
//           api.get(`pms/reservations/${selectedId}`),
//           api.get(`pms/reservations/${selectedId}/payments`),
//           api.get(`pms/pos/reservations/${selectedId}`),
//           api.get(`/pms/taxes`),
//         ]);

//         if (resRes.status === "fulfilled") {
//           const data = resRes.value.data?.data ?? null;
//           setReservation(data);
//           if (data) {
//             const nights = calculateNights(data.check_in, data.check_out);
//             const subtotal = calculateRoomSubtotal(
//               data.room?.room_price,
//               data.rate_type?.base_price,
//               nights
//             );

//             setRoomSubtotal(subtotal);
//           }
//         }
//         if (payRes.status === "fulfilled") {
//           const arr = Array.isArray(payRes.value.data)
//             ? payRes.value.data
//             : Array.isArray(payRes.value.data?.data)
//             ? payRes.value.data.data
//             : [];
//           setPayments(arr);
//         }
//         if (posRes.status === "fulfilled") {
//           const sales = Array.isArray(posRes.value.data)
//             ? posRes.value.data
//             : posRes.value.data?.data ?? [];
//           // flatten
//           const flat = [];
//           let t = 0;
//           sales.forEach((sale) => {
//             if (
//               String(sale.payment_mode).toLowerCase() === "pay later" &&
//               String(sale.status).toLowerCase() === "open"
//             ) {
//               t += safeNum(sale.total);
//               sale.items?.forEach((it) => {
//                 flat.push({
//                   id: it.id,
//                   name: it.name,
//                   quantity: it.quantity,
//                   amount: it.line_total,
//                 });
//               });
//             }
//           });
//           setPosItems(flat);
//           setPosTotal(t);
//         }
//         if (taxesRes.status === "fulfilled") {
//           const arr = Array.isArray(taxesRes.value.data?.data)
//             ? taxesRes.value.data.data
//             : Array.isArray(taxesRes.value.data)
//             ? taxesRes.value.data
//             : [];
//           setTaxDefs(arr);
//         }
//       } catch (err) {
//         // ignore
//       }

//       setPaymentAmt("");
//       setPaymentMethod("");
//       setPaymentRemark("");
//       setShowPaymentModal(false);
//     } catch (err) {
//       alert("Payment failed");
//     } finally {
//       setSubmittingPayment(false);
//     }
//   };

//   // checkout action (only enabled when dueAmount <= 0)
//   const handleCheckout = async () => {
//     if (!selectedId) return;
//     if (dueAmount > 0) {
//       alert("Outstanding due must be zero before checkout");
//       return;
//     }
//     try {
//       await api.post(`pms/reservations/${selectedId}/checkout`, {
//         action: "checkout",
//       });

//       // refresh list (to remove from checked-in)
//       const res = await api.get("pms/reservations/checked-in");
//       setCheckedInReservations(
//         Array.isArray(res.data) ? res.data : res.data?.data ?? []
//       );
//       setSelectedId("");
//     } catch (err) {
//       alert("Checkout failed");
//     }
//   };

//   // small render helpers
//   const rv = (k, fallback = "-") => reservation?.[k] ?? fallback;
//   const r = (k, fallback = "-") => reservation?.room?.[k] ?? fallback;
//   const g = (k, fallback = "-") => reservation?.guest?.[k] ?? fallback;

//   return (
//     <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
//       <div className="row g-3">
//         {/* Header + dropdown */}
//         <div className="col-sm-12">
//           <div className="d-flex align-items-center justify-content-between flex-wrap">
//             <h3 className="fw-bold mb-0">Check Out</h3>

//             <div className="col-auto d-flex w-sm-100">
//               <select
//                 className="form-select"
//                 value={selectedId}
//                 onChange={(e) => setSelectedId(e.target.value)}
//               >
//                 <option value="">Choose Room No</option>
//                 {loadingList && <option>Loading...</option>}
//                 {!loadingList && checkedInReservations.length === 0 && (
//                   <option value="">No checked-in reservations</option>
//                 )}
//                 {checkedInReservations.map((item) => (
//                   <option key={item.id} value={item.id}>
//                     {item.room?.room_number ??
//                       `Room-${item.room_id ?? item.id}`}{" "}
//                     — {item.guest?.name ?? "Guest"}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>
//         </div>

//         {/* errors */}
//         {error && (
//           <div className="col-12">
//             <div className="alert alert-danger mb-0">{error}</div>
//           </div>
//         )}

//         {/* prompt */}
//         {!selectedId && !loadingReservation && (
//           <div className="col-12 text-center mt-4">
//             <h5>Select a checked-in room to load checkout details</h5>
//           </div>
//         )}

//         {loadingReservation && (
//           <div className="col-12 text-center mt-4">
//             <h6>Loading reservation details...</h6>
//           </div>
//         )}
//         {/* main UI when reservation loaded */}
//         {reservation && !loadingReservation && (
//           <>
//             {/* Customer Details */}
//             <div className="col-md-12">
//               <div className="card">
//                 <div className="card-header">
//                   <h6 className="card-title">Customer Details</h6>
//                 </div>
//                 <div className="card-body">
//                   <div className="table-responsive">
//                     <table className="table table-sm table-bordered mb-0">
//                       <tbody>
//                         <tr>
//                           <th>Name</th>
//                           <td>
//                             {`${g("title", "")} ${g("name")}`.trim() || "-"}
//                           </td>
//                         </tr>
//                         <tr>
//                           <th>Gender</th>
//                           <td>{g("gender")}</td>
//                         </tr>
//                         <tr>
//                           <th>Email</th>
//                           <td>{g("email")}</td>
//                         </tr>
//                         <tr>
//                           <th>Mobile</th>
//                           <td>{g("mobile_no")}</td>
//                         </tr>
//                         <tr>
//                           <th>ID Type</th>
//                           <td>{g("identity_type")}</td>
//                         </tr>
//                         <tr>
//                           <th>ID No</th>
//                           <td>{g("identity_no")}</td>
//                         </tr>
//                         <tr>
//                           <th>Booking Ref</th>
//                           <td>{rv("booking_reference_no")}</td>
//                         </tr>
//                         <tr>
//                           <th>Booking Type</th>
//                           <td>{rv("booking_type")}</td>
//                         </tr>
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Billing Details */}
//             <div className="col-md-12">
//               <div className="card">
//                 <div className="card-header">
//                   <h6 className="card-title">Billing Details</h6>
//                 </div>
//                 <div className="card-body">
//                   <div className="table-responsive">
//                     <table className="table table-sm table-bordered mb-0">
//                       <tbody>
//                         <tr>
//                           <th>Room No</th>
//                           <td>{r("room_number")}</td>
//                         </tr>
//                         <tr>
//                           <th>Room Type / Size</th>
//                           <td>{r("room_size")}</td>
//                         </tr>
//                         <tr>
//                           <th>Room Price</th>
//                           <td>{r("room_price")}</td>
//                         </tr>
//                         <tr>
//                           <th>Check-in</th>
//                           <td>{formatDate(rv("check_in"))}</td>
//                         </tr>
//                         <tr>
//                           <th>Check-out</th>
//                           <td>{formatDate(rv("check_out"))}</td>
//                         </tr>
//                         <tr>
//                           <th>Adults</th>
//                           <td>{rv("adults", 0)}</td>
//                         </tr>
//                         <tr>
//                           <th>Children</th>
//                           <td>{rv("children", 0)}</td>
//                         </tr>
//                         <tr>
//                           <th>Bed Type</th>
//                           <td>{rv("bed_type")}</td>
//                         </tr>
//                         <tr>
//                           <th>Extra Bed Charge</th>
//                           <td>{rv("bed_charge")}</td>
//                         </tr>
//                         <tr>
//                           <th>Room Subtotal</th>
//                           <td>{safeNum(roomSubtotal).toFixed(2)}</td>
//                         </tr>
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Bill Details (main table) */}
//             <div className="col-md-12">
//               <div className="card">
//                 <div className="card-header">
//                   <h6 className="card-title">Bill Details</h6>
//                 </div>
//                 <div className="card-body">
//                   <div className="table-responsive">
//                     <div className="table-wrapper">
//                       <table className="table table-bordered mb-0">
//                         <thead>
//                           <tr>
//                             <th>Room No.</th>
//                             <th>Date</th>
//                             <th>Room Type</th>
//                             <th>Guest Details</th>
//                             <th className="text-center">Room Rent Details</th>
//                             <th>Tax Details</th>
//                             <th>Total Amount</th>
//                           </tr>
//                         </thead>

//                         <tbody>
//                           <tr>
//                             <td rowSpan="2">
//                               <strong className="d-block">
//                                 {r("room_number")}
//                               </strong>
//                               <span>{r("room_size")}</span>
//                             </td>

//                             <td rowSpan="2">
//                               <div>
//                                 {formatDate(rv("check_in"))}
//                                 <br />
//                                 to
//                                 <br />
//                                 {formatDate(rv("check_out"))}
//                               </div>
//                             </td>

//                             <td rowSpan="2">{r("room_size")}</td>

//                             <td>
//                               <div className="text-muted">
//                                 Adults: {rv("adults", 0)}
//                               </div>
//                             </td>

//                             <td rowSpan="2">
//                               <table className="table table-bordered">
//                                 <thead>
//                                   <tr>
//                                     <th>#</th>
//                                     <th>From Date</th>
//                                     <th>To Date</th>
//                                     <th>NoD</th>
//                                     <th>Rent/ Day</th>
//                                     <th>Rent Discount</th>
//                                     <th>Tot. Rent</th>
//                                   </tr>
//                                 </thead>
//                                 <tbody>
//                                   <tr>
//                                     <td>1</td>
//                                     <td>{formatDate(rv("check_in"))}</td>
//                                     <td>{formatDate(rv("check_out"))}</td>
//                                     <td>{reservation?.total_nights ?? "-"}</td>
//                                     <td>{r("room_price") ?? "-"}</td>
//                                     <td>{rv("discount_percent", 0)}</td>
//                                     <td>{safeNum(roomSubtotal).toFixed(2)}</td>
//                                   </tr>
//                                 </tbody>
//                               </table>
//                             </td>

//                             <td>
//                               <div className="text-muted">Tax Details:</div>
//                               <div>
//                                 {loadingTaxes && <div>Loading taxes...</div>}
//                                 {!loadingTaxes &&
//                                   taxesComputed.length === 0 && <div>-</div>}
//                                 {!loadingTaxes &&
//                                   taxesComputed.map((t, i) => (
//                                     <div key={t.id ?? i}>
//                                       ({t.name} {t.percent}%){" "}
//                                       {safeNum(t.amount).toFixed(2)}
//                                     </div>
//                                   ))}
//                               </div>
//                             </td>

//                             <td rowSpan="2">
//                               {(
//                                 safeNum(roomSubtotal) +
//                                 // safeNum(taxTotal) +
//                                 safeNum(posTotal)
//                               ).toFixed(2)}
//                             </td>
//                           </tr>

//                           <tr>
//                             <td>
//                               <div className="text-muted">
//                                 Children: {rv("children", 0)}
//                               </div>
//                             </td>
//                             <td>
//                               <div className="text-muted">Subtotal:</div>
//                               <div>{safeNum(roomSubtotal).toFixed(2)}</div>
//                               <div className="text-muted">Total Tax:</div>
//                               <div>{safeNum(taxTotal).toFixed(2)}</div>
//                             </td>
//                           </tr>

//                           {/* POS items (paylater) row */}
//                           <tr>
//                             <td colSpan="7">
//                               <strong>POS (Pay-Later) Items</strong>
//                               <div>
//                                 {loadingPos && <div>Loading POS items...</div>}
//                                 {!loadingPos && posItems.length === 0 && (
//                                   <div className="text-muted">
//                                     No POS pay-later items
//                                   </div>
//                                 )}
//                                 {!loadingPos && posItems.length > 0 && (
//                                   <table className="table table-sm table-bordered mt-2">
//                                     <thead>
//                                       <tr>
//                                         <th>#</th>
//                                         <th>Item</th>
//                                         <th>Qty</th>
//                                         <th>Amount</th>
//                                       </tr>
//                                     </thead>
//                                     <tbody>
//                                       {posItems.map((it, i) => (
//                                         <tr key={it.id ?? i}>
//                                           <td>{i + 1}</td>
//                                           <td>{it.name ?? "-"}</td>
//                                           <td>{it.quantity ?? "-"}</td>
//                                           <td>
//                                             {safeNum(
//                                               it.amount ?? it.line_total
//                                             ).toFixed(2)}
//                                           </td>
//                                         </tr>
//                                       ))}
//                                       <tr>
//                                         <td colSpan="3" className="text-end">
//                                           <strong>POS Total</strong>
//                                         </td>
//                                         <td>
//                                           <strong>
//                                             {safeNum(posTotal).toFixed(2)}
//                                           </strong>
//                                         </td>
//                                       </tr>
//                                     </tbody>
//                                   </table>
//                                 )}
//                               </div>
//                             </td>
//                           </tr>
//                         </tbody>
//                       </table>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Additional Charges + Payments summary + Add Payment button */}
//             <div className="col-md-12">
//               <div className="card">
//                 <div className="card-header">
//                   <h6 className="card-title">Additional Charges</h6>
//                 </div>
//                 <div className="card-body">
//                   <div className="table-responsive">
//                     <table className="table table-sm table-bordered mb-0">
//                       <tbody>
//                         <tr>
//                           <th scope="row">Additional Charges</th>
//                           <td>
//                             <input
//                               type="number"
//                               className="form-control"
//                               placeholder="Extra Charge"
//                             />
//                           </td>
//                         </tr>
//                         <tr>
//                           <th scope="row">Comments</th>
//                           <td>
//                             <textarea className="form-control" />
//                           </td>
//                         </tr>
//                       </tbody>
//                     </table>

//                     <hr />

//                     <h6 className="card-title mb-3 d-flex justify-content-between align-items-center">
//                       Payments Details
//                       <button
//                         className="btn btn-sm btn-primary"
//                         onClick={() => setShowPaymentModal(true)}
//                       >
//                         + Add Payment
//                       </button>
//                     </h6>

//                     {/* payments table */}
//                     <table className="table table-sm table-bordered mb-0">
//                       <thead>
//                         <tr>
//                           <th>#</th>
//                           <th>Method</th>
//                           <th>Amount</th>
//                           <th>Remarks</th>
//                           <th>Date</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {!loadingPayments && payments.length === 0 && (
//                           <tr>
//                             <td colSpan="5" className="text-center py-3">
//                               No payments yet
//                             </td>
//                           </tr>
//                         )}

//                         {payments.map((p, i) => (
//                           <tr key={p.id ?? i}>
//                             <td>{i + 1}</td>
//                             <td>{p.mode ?? p.payment_method ?? "-"}</td>
//                             <td>{Number(p.amount ?? p.amt ?? 0).toFixed(2)}</td>
//                             <td>{p.remark ?? p.remarks ?? "-"}</td>
//                             <td>
//                               {formatDate(
//                                 p.created_at ?? p.date ?? p.timestamp
//                               )}
//                             </td>
//                           </tr>
//                         ))}
//                         <tr>
//                           <td colSpan="1" className="text-end">
//                             <strong>Payments Total</strong>
//                           </td>
//                           <td colSpan="4">
//                             <strong>{safeNum(paymentsTotal).toFixed(2)}</strong>
//                           </td>
//                         </tr>
//                       </tbody>
//                     </table>

//                     <hr />

//                     <h6>Payment Summary</h6>
//                     <table className="table table-sm table-bordered mb-0">
//                       <tbody>
//                         <tr>
//                           <th>Net Payable Amt</th>
//                           <td>
//                             {(
//                               safeNum(roomSubtotal) +
//                               // safeNum(taxTotal) +
//                               safeNum(posTotal)
//                             ).toFixed(2)}
//                           </td>
//                         </tr>
//                         <tr>
//                           <th>Payments Collected</th>
//                           <td>{safeNum(paymentsTotal).toFixed(2)}</td>
//                         </tr>
//                         <tr>
//                           <th>Due Amount</th>
//                           <td>{safeNum(dueAmount).toFixed(2)}</td>
//                         </tr>
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Special Discount & Balance (kept simple) */}
//             <div className="col-md-12">
//               <div className="card">
//                 <div className="card-header">
//                   <h6 className="card-title">Special Discount</h6>
//                 </div>
//                 <div className="card-body">
//                   <table className="table table-sm table-bordered mb-0">
//                     <tbody>
//                       <tr>
//                         <th>Discount Type</th>
//                         <td>
//                           <select className="form-select">
//                             <option defaultValue="selected">
//                               Choose Discount
//                             </option>
//                             <option value="1">Friends</option>
//                             <option value="2">Regular Customer</option>
//                             <option value="3">MD Guest</option>
//                           </select>
//                         </td>
//                       </tr>
//                       <tr>
//                         <th>Discount Amt</th>
//                         <td>
//                           <input
//                             type="number"
//                             className="form-control"
//                             placeholder="Discount Amt"
//                           />
//                         </td>
//                       </tr>
//                       <tr>
//                         <th>Remarks</th>
//                         <td>
//                           <textarea className="form-control" />
//                         </td>
//                       </tr>
//                     </tbody>
//                   </table>

//                   <hr />

//                   <h6 className="card-title mb-3">Balance Details</h6>
//                   <table className="table table-sm table-bordered mb-0">
//                     <tbody>
//                       <tr>
//                         <th>Remain Amt</th>
//                         <td>{safeNum(dueAmount).toFixed(2)}</td>
//                       </tr>
//                       <tr>
//                         <th>Collected Amt</th>
//                         <td>{safeNum(paymentsTotal).toFixed(2)}</td>
//                       </tr>
//                       <tr>
//                         <th>Change Amt</th>
//                         <td>
//                           {Math.max(
//                             0,
//                             safeNum(paymentsTotal) -
//                               (safeNum(roomSubtotal) +
//                                 safeNum(taxTotal) +
//                                 safeNum(posTotal))
//                           ).toFixed(2)}
//                         </td>
//                       </tr>
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </div>

//             {/* Checkout Button */}
//             <div className="col-sm-12 text-end">
//               <button
//                 className="btn btn-primary"
//                 disabled={dueAmount > 0}
//                 onClick={handleCheckout}
//               >
//                 Checkout
//               </button>
//               {dueAmount > 0 && (
//                 <small className="text-muted ms-2">
//                   {" "}
//                   (Due must be 0 to checkout)
//                 </small>
//               )}
//             </div>

//             {/* Add Payment Modal */}
//             {showPaymentModal && (
//               <div
//                 className="modal fade show d-block"
//                 tabIndex="-1"
//                 style={{ background: "rgba(0,0,0,0.5)" }}
//               >
//                 <div className="modal-dialog">
//                   <div className="modal-content">
//                     <div className="modal-header">
//                       <h5 className="modal-title">Add Payment</h5>
//                       <button
//                         type="button"
//                         className="btn-close"
//                         onClick={() => setShowPaymentModal(false)}
//                       ></button>
//                     </div>

//                     <div className="modal-body">
//                       <div className="mb-3">
//                         <label className="form-label">Payment Method</label>
//                         <select
//                           className="form-select"
//                           value={paymentMethod}
//                           onChange={(e) => setPaymentMethod(e.target.value)}
//                         >
//                           <option value="">Choose</option>
//                           <option value="cash">Cash</option>
//                           <option value="card">Card</option>
//                           <option value="upi">UPI</option>
//                           <option value="bank">Bank Transfer</option>
//                         </select>
//                       </div>

//                       <div className="mb-3">
//                         <label className="form-label">Amount</label>
//                         <input
//                           type="number"
//                           className="form-control"
//                           value={paymentAmt}
//                           onChange={(e) => setPaymentAmt(e.target.value)}
//                           placeholder="Enter amount"
//                         />
//                       </div>

//                       <div className="mb-3">
//                         <label className="form-label">Remarks (optional)</label>
//                         <textarea
//                           className="form-control"
//                           value={paymentRemark}
//                           onChange={(e) => setPaymentRemark(e.target.value)}
//                         />
//                       </div>
//                     </div>

//                     <div className="modal-footer">
//                       <button
//                         className="btn btn-secondary"
//                         onClick={() => setShowPaymentModal(false)}
//                         disabled={submittingPayment}
//                       >
//                         Cancel
//                       </button>
//                       <button
//                         className="btn btn-primary"
//                         onClick={submitPayment}
//                         disabled={submittingPayment}
//                       >
//                         {submittingPayment ? "Submitting..." : "Submit"}
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default RoomCheckout;

import React, { useCallback, useEffect, useMemo, useState } from "react";
import api from "../../../../../api/axios";

// ---------- Helpers ----------
const formatDate = (iso) => {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleDateString("en-GB"); // DD/MM/YYYY
  } catch {
    return iso;
  }
};

const safeNum = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

const calcNights = (checkIn, checkOut) => {
  try {
    const d1 = checkIn ? new Date(checkIn) : null;
    const d2 = checkOut ? new Date(checkOut) : null;
    if (!d1 || !d2 || Number.isNaN(d1.getTime()) || Number.isNaN(d2.getTime()))
      return 1;
    const diffMs = Math.max(0, d2.getTime() - d1.getTime());
    const days = Math.ceil(diffMs / (1000 * 60 * 60 * 24));
    return Math.max(1, days);
  } catch {
    return 1;
  }
};

// ---------- Component ----------
const RoomCheckout = () => {
  // lists & selected
  const [checkedInReservations, setCheckedInReservations] = useState([]);
  const [selectedId, setSelectedId] = useState("");
  const [reservation, setReservation] = useState(null);

  // payments, taxes, pos
  const [payments, setPayments] = useState([]);
  const [taxDefs, setTaxDefs] = useState([]); // from API
  const [taxesComputed, setTaxesComputed] = useState([]); // [{id,name,percent,amount}]
  const [posItems, setPosItems] = useState([]);
  const [posTotal, setPosTotal] = useState(0);

  // ui state
  const [loadingList, setLoadingList] = useState(false);
  const [loadingReservation, setLoadingReservation] = useState(false);
  const [loadingPayments, setLoadingPayments] = useState(false);
  const [loadingPos, setLoadingPos] = useState(false);
  const [loadingTaxes, setLoadingTaxes] = useState(false);
  const [error, setError] = useState(null);

  // payment modal
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentAmt, setPaymentAmt] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [paymentRemark, setPaymentRemark] = useState("");
  const [submittingPayment, setSubmittingPayment] = useState(false);

  // totals
  const [roomSubtotal, setRoomSubtotal] = useState(0);
  const [taxTotal, setTaxTotal] = useState(0);
  const [paymentsTotal, setPaymentsTotal] = useState(0);
  const [dueAmount, setDueAmount] = useState(0);

  // ---------- Load checked-in reservations & taxDefs (parallel) ----------
  useEffect(() => {
    let mounted = true;
    const loadAllMeta = async () => {
      setLoadingList(true);
      setLoadingTaxes(true);

      try {
        const [listRes, taxesRes] = await Promise.allSettled([
          api.get("pms/reservations/checked-in"),
          api.get("/pms/taxes"),
        ]);

        if (!mounted) return;

        if (listRes.status === "fulfilled") {
          const arr =
            Array.isArray(listRes.value.data) ||
            Array.isArray(listRes.value.data?.data)
              ? Array.isArray(listRes.value.data)
                ? listRes.value.data
                : listRes.value.data.data
              : [];
          setCheckedInReservations(arr);
        } else {
          setCheckedInReservations([]);
        }

        if (taxesRes.status === "fulfilled") {
          const arr =
            Array.isArray(taxesRes.value.data?.data) ||
            Array.isArray(taxesRes.value.data)
              ? Array.isArray(taxesRes.value.data?.data)
                ? taxesRes.value.data.data
                : taxesRes.value.data
              : [];
          setTaxDefs(arr);
        } else {
          setTaxDefs([]);
        }
      } finally {
        if (mounted) {
          setLoadingList(false);
          setLoadingTaxes(false);
        }
      }
    };

    loadAllMeta();
    return () => {
      mounted = false;
    };
  }, []);

  // ---------- Load POS pay-later for a reservation ----------
  const loadPosForReservation = useCallback(async (id) => {
    setLoadingPos(true);
    try {
      const res = await api.get(`pms/pos/reservations/${id}`);
      const sales = Array.isArray(res.data) ? res.data : res.data?.data ?? [];

      const flatItems = [];
      let total = 0;

      sales.forEach((sale) => {
        const mode = String(sale.payment_mode ?? "").toLowerCase();
        const status = String(sale.status ?? "").toLowerCase();
        if (mode === "pay later" && status === "open") {
          total += safeNum(sale.total);
          sale.items?.forEach((it) =>
            flatItems.push({
              id: it.id,
              name: it.name,
              quantity: it.quantity,
              amount: it.line_total,
            })
          );
        }
      });

      setPosItems(flatItems);
      setPosTotal(total);
    } catch {
      setPosItems([]);
      setPosTotal(0);
    } finally {
      setLoadingPos(false);
    }
  }, []);

  // ---------- Load reservation + payments + pos whenever selectedId changes ----------
  const loadReservationData = useCallback(
    async (id) => {
      if (!id) {
        setReservation(null);
        setPayments([]);
        setPosItems([]);
        setTaxesComputed([]);
        setRoomSubtotal(0);
        setTaxTotal(0);
        setPosTotal(0);
        setPaymentsTotal(0);
        setDueAmount(0);
        return;
      }

      setLoadingReservation(true);
      setError(null);

      try {
        const res = await api.get(`pms/reservations/${id}`);
        const reservationData = res.data?.data ?? null;
        setReservation(reservationData);

        // payments
        setLoadingPayments(true);
        try {
          const p = await api.get(`pms/reservations/${id}/payments`);
          const pData = Array.isArray(p.data)
            ? p.data
            : Array.isArray(p.data?.data)
            ? p.data.data
            : [];
          setPayments(pData);
        } catch {
          setPayments([]);
        } finally {
          setLoadingPayments(false);
        }

        // pos
        await loadPosForReservation(id);

        // compute room subtotal ALWAYS from room_price + rate_type.base_price * nights (Option A)
        if (reservationData) {
          const roomPrice = safeNum(reservationData?.room?.room_price);
          const ratePrice = safeNum(reservationData?.rate_type?.base_price);
          const nights =
            safeNum(reservationData?.total_nights) ||
            calcNights(reservationData?.check_in, reservationData?.check_out);

          const computedRoomSubtotal = (roomPrice + ratePrice) * nights;
          setRoomSubtotal(Number(computedRoomSubtotal.toFixed(2)));
        } else {
          setRoomSubtotal(0);
        }
      } catch (err) {
        setError("Failed to load reservation details");
        setReservation(null);
        setPayments([]);
        setPosItems([]);
        setTaxesComputed([]);
      } finally {
        setLoadingReservation(false);
      }
    },
    [loadPosForReservation]
  );

  useEffect(() => {
    loadReservationData(selectedId);
  }, [selectedId, loadReservationData]);

  // ---------- Compute taxes from taxDefs and reservation (Option A) ----------
  useEffect(() => {
    if (!reservation) {
      setTaxesComputed([]);
      setTaxTotal(0);
      return;
    }

    if (!taxDefs || taxDefs.length === 0) {
      setTaxesComputed([]);
      setTaxTotal(0);
      return;
    }

    const nights = calcNights(reservation.check_in, reservation.check_out);

    const basePrice = safeNum(reservation?.room?.room_price ?? 0);
    const ratePrice = safeNum(reservation?.rate_type?.base_price ?? 0);
    const roomBase = (basePrice + ratePrice) * nights;

    const computed = taxDefs.map((t) => {
      const pct = safeNum(t.percentage ?? t.percent);
      const amount = (pct / 100) * roomBase;
      return {
        id: t.id,
        name: t.name,
        percent: pct,
        amount: Number(amount.toFixed(2)),
      };
    });

    setTaxesComputed(computed);
    const tot = computed.reduce((s, x) => s + safeNum(x.amount), 0);
    setTaxTotal(Number(tot.toFixed(2)));
  }, [taxDefs, reservation]);

  // ---------- Recompute totals whenever payments, taxesComputed, posTotal or roomSubtotal change ----------
  useEffect(() => {
    const pTotal = (Array.isArray(payments) ? payments : []).reduce(
      (s, x) => s + safeNum(x.amount ?? x.amt ?? x.value),
      0
    );

    const tTotal = (Array.isArray(taxesComputed) ? taxesComputed : []).reduce(
      (s, x) => s + safeNum(x.amount),
      0
    );

    const posT = safeNum(posTotal);

    setPaymentsTotal(Number(pTotal.toFixed(2)));
    setTaxTotal(Number(tTotal.toFixed(2)));

    const due = safeNum(roomSubtotal) + tTotal + posT - pTotal;
    setDueAmount(Number(due.toFixed(2)));
  }, [payments, taxesComputed, posTotal, roomSubtotal]);

  // ---------- submit payment ----------
  const submitPayment = async () => {
    if (!selectedId) {
      alert("Select a reservation first");
      return;
    }
    if (!paymentAmt || Number(paymentAmt) <= 0) {
      alert("Enter valid payment amount");
      return;
    }
    if (!paymentMethod) {
      alert("Choose a payment method");
      return;
    }

    setSubmittingPayment(true);
    try {
      await api.post(`pms/reservations/${selectedId}/payments`, {
        amount: Number(paymentAmt),
        mode: paymentMethod,
        remarks: paymentRemark,
      });

      // reload payments, reservation, pos and taxes (best effort)
      await loadReservationData(selectedId);

      // also re-fetch payments explicitly to ensure up-to-date
      try {
        const p = await api.get(`pms/reservations/${selectedId}/payments`);
        const pData = Array.isArray(p.data)
          ? p.data
          : Array.isArray(p.data?.data)
          ? p.data.data
          : [];
        setPayments(pData);
      } catch {
        // ignore
      }

      setPaymentAmt("");
      setPaymentMethod("");
      setPaymentRemark("");
      setShowPaymentModal(false);
    } catch (err) {
      alert("Payment failed");
    } finally {
      setSubmittingPayment(false);
    }
  };

  // ---------- checkout ----------
  const handleCheckout = async () => {
    if (!selectedId) return;
    if (dueAmount > 0) {
      alert("Outstanding due must be zero before checkout");
      return;
    }
    try {
      await api.post(`pms/reservations/${selectedId}/checkout`, {
        action: "checkout",
      });

      // refresh checked-in list and clear selection
      const res = await api.get("pms/reservations/checked-in");
      const arr =
        Array.isArray(res.data) || Array.isArray(res.data?.data)
          ? Array.isArray(res.data)
            ? res.data
            : res.data.data
          : [];
      setCheckedInReservations(arr);
      setSelectedId("");
    } catch (err) {
      alert("Checkout failed");
    }
  };

  // ---------- Render helpers ----------
  const rv = (k, fallback = "-") => reservation?.[k] ?? fallback;
  const rt = (k, fallback = "-") => reservation?.rate_type?.[k] ?? fallback;
  const r = (k, fallback = "-") => reservation?.room?.[k] ?? fallback;
  const g = (k, fallback = "-") => reservation?.guest?.[k] ?? fallback;

  // ---------- Memoized values to avoid re-rendering expensive arrays ----------
  const paymentsList = useMemo(() => payments || [], [payments]);
  const taxesList = useMemo(() => taxesComputed || [], [taxesComputed]);

  // ---------- UI ----------
  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="row g-3">
        {/* Header + dropdown */}
        <div className="col-sm-12">
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <h3 className="fw-bold mb-0">Check Out</h3>

            <div className="col-auto d-flex w-sm-100">
              <select
                className="form-select"
                value={selectedId}
                onChange={(e) => setSelectedId(e.target.value)}
              >
                <option value="">Choose Room No</option>
                {loadingList && <option>Loading...</option>}
                {!loadingList && checkedInReservations.length === 0 && (
                  <option value="">No checked-in reservations</option>
                )}
                {checkedInReservations.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.room?.room_number ??
                      `Room-${item.room_id ?? item.id}`}{" "}
                    — {item.guest?.name ?? "Guest"}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        {/* errors */}
        {error && (
          <div className="col-12">
            <div className="alert alert-danger mb-0">{error}</div>
          </div>
        )}

        {/* prompt */}
        {!selectedId && !loadingReservation && (
          <div className="col-12 text-center mt-4">
            <h5>Select a checked-in room to load checkout details</h5>
          </div>
        )}

        {loadingReservation && (
          <div className="col-12 text-center mt-4">
            <h6>Loading reservation details...</h6>
          </div>
        )}

        {/* main UI when reservation loaded */}
        {reservation && !loadingReservation && (
          <>
            {/* Customer Details */}
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <h6 className="card-title">Customer Details</h6>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-sm table-bordered mb-0">
                      <tbody>
                        <tr>
                          <th>Name</th>
                          <td>
                            {`${g("title", "")} ${g("name")}`.trim() || "-"}
                          </td>
                        </tr>
                        <tr>
                          <th>Gender</th>
                          <td>{g("gender")}</td>
                        </tr>
                        <tr>
                          <th>Email</th>
                          <td>{g("email")}</td>
                        </tr>
                        <tr>
                          <th>Mobile</th>
                          <td>{g("mobile_no")}</td>
                        </tr>
                        <tr>
                          <th>ID Type</th>
                          <td>{g("identity_type")}</td>
                        </tr>
                        <tr>
                          <th>ID No</th>
                          <td>{g("identity_no")}</td>
                        </tr>
                        <tr>
                          <th>Booking Ref</th>
                          <td>{rv("booking_reference_no")}</td>
                        </tr>
                        <tr>
                          <th>Booking Type</th>
                          <td>{rv("booking_type")}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            {/* Billing Details */}
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <h6 className="card-title">Billing Details</h6>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table table-sm table-bordered mb-0">
                      <tbody>
                        <tr>
                          <th>Room No</th>
                          <td>{r("room_number")}</td>
                        </tr>
                        <tr>
                          <th>Room Type / Size</th>
                          <td>{r("room_size")}</td>
                        </tr>
                        <tr>
                          <th>Room Tarrif</th>
                          <td>{rt("name")}</td>
                        </tr>
                        <tr>
                          <th>Check-in</th>
                          <td>{formatDate(rv("check_in"))}</td>
                        </tr>
                        <tr>
                          <th>Check-out</th>
                          <td>{formatDate(rv("check_out"))}</td>
                        </tr>
                        <tr>
                          <th>Adults</th>
                          <td>{rv("adults", 0)}</td>
                        </tr>
                        <tr>
                          <th>Children</th>
                          <td>{rv("children", 0)}</td>
                        </tr>
                        <tr>
                          <th>Bed Type</th>
                          <td>{rv("bed_type")}</td>
                        </tr>
                        <tr>
                          <th>Extra Bed Charge</th>
                          <td>{rv("bed_charge")}</td>
                        </tr>
                        {/* <tr>
                          <th>Room Subtotal</th>
                          <td>{safeNum(roomSubtotal).toFixed(2)}</td>
                        </tr> */}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            {/* Bill Details (main table) */}
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <h6 className="card-title">Bill Details</h6>
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <div className="table-wrapper">
                      <table className="table table-bordered mb-0">
                        <thead>
                          <tr>
                            <th>Room No.</th>
                            <th>Date</th>
                            <th>Room Type</th>
                            <th>Guest Details</th>
                            <th className="text-center">Room Rent Details</th>
                            <th>Tax Details</th>
                            <th>Total Amount</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr>
                            <td rowSpan="2">
                              <strong className="d-block">
                                {r("room_number")}
                              </strong>
                              <span>{r("room_size")}</span>
                            </td>

                            <td rowSpan="2">
                              <div>
                                {formatDate(rv("check_in"))}
                                <br />
                                to
                                <br />
                                {formatDate(rv("check_out"))}
                              </div>
                            </td>

                            <td rowSpan="2">{r("room_size")}</td>

                            <td>
                              <div className="text-muted">
                                Adults: {rv("adults", 0)}
                              </div>
                            </td>

                            <td rowSpan="2">
                              <table className="table table-bordered">
                                <thead>
                                  <tr>
                                    <th>#</th>
                                    <th>From Date</th>
                                    <th>To Date</th>
                                    <th>NoD</th>
                                    <th>Rent/ Day</th>
                                    <th>Rent Discount</th>
                                    <th>Tot. Rent</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>1</td>
                                    <td>{formatDate(rv("check_in"))}</td>
                                    <td>{formatDate(rv("check_out"))}</td>
                                    <td>
                                      {reservation?.total_nights ??
                                        calcNights(
                                          reservation?.check_in,
                                          reservation?.check_out
                                        )}
                                    </td>
                                    <td>{safeNum(roomSubtotal).toFixed(2)}</td>
                                    <td>{rv("discount_percent", 0)}</td>
                                    <td>{safeNum(roomSubtotal).toFixed(2)}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </td>

                            <td>
                              <div className="text-muted">Tax Details:</div>
                              <div>
                                {loadingTaxes && <div>Loading taxes...</div>}
                                {!loadingTaxes && taxesList.length === 0 && (
                                  <div>-</div>
                                )}
                                {!loadingTaxes &&
                                  taxesList.map((t, i) => (
                                    <div key={t.id ?? i}>
                                      ({t.name} {t.percent}%){" "}
                                      {safeNum(t.amount).toFixed(2)}
                                    </div>
                                  ))}
                              </div>
                            </td>

                            <td rowSpan="2">
                              {(
                                safeNum(roomSubtotal) +
                                safeNum(taxTotal) +
                                safeNum(posTotal)
                              ).toFixed(2)}
                            </td>
                          </tr>

                          <tr>
                            <td>
                              <div className="text-muted">
                                Children: {rv("children", 0)}
                              </div>
                            </td>
                            <td>
                              <div className="text-muted">Subtotal:</div>
                              <div>{safeNum(roomSubtotal).toFixed(2)}</div>
                              <div className="text-muted">Total With Tax:</div>
                              <div>{safeNum(taxTotal).toFixed(2)}</div>
                            </td>
                          </tr>

                          {/* POS items (paylater) row */}
                          <tr>
                            <td colSpan="7">
                              <strong>POS (Pay-Later) Items</strong>
                              <div>
                                {loadingPos && <div>Loading POS items...</div>}
                                {!loadingPos && posItems.length === 0 && (
                                  <div className="text-muted">
                                    No POS pay-later items
                                  </div>
                                )}
                                {!loadingPos && posItems.length > 0 && (
                                  <table className="table table-sm table-bordered mt-2">
                                    <thead>
                                      <tr>
                                        <th>#</th>
                                        <th>Item</th>
                                        <th>Qty</th>
                                        <th>Amount</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {posItems.map((it, i) => (
                                        <tr key={it.id ?? i}>
                                          <td>{i + 1}</td>
                                          <td>{it.name ?? "-"}</td>
                                          <td>{it.quantity ?? "-"}</td>
                                          <td>
                                            {safeNum(
                                              it.amount ?? it.line_total
                                            ).toFixed(2)}
                                          </td>
                                        </tr>
                                      ))}
                                      <tr>
                                        <td colSpan="3" className="text-end">
                                          <strong>POS Total</strong>
                                        </td>
                                        <td>
                                          <strong>
                                            {safeNum(posTotal).toFixed(2)}
                                          </strong>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                )}
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Additional Charges + Payments summary + Add Payment button */}
            <div className="col-md-12">
              <div className="card">
                {/* <div className="card-header">
                  <h6 className="card-title">Additional Charges</h6>
                </div> */}
                <div className="card-body">
                  <div className="table-responsive">
                    {/* <table className="table table-sm table-bordered mb-0">
                      <tbody>
                        <tr>
                          <th scope="row">Additional Charges</th>
                          <td>
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Extra Charge"
                            />
                          </td>
                        </tr>
                        <tr>
                          <th scope="row">Comments</th>
                          <td>
                            <textarea className="form-control" />
                          </td>
                        </tr>
                      </tbody>
                    </table> */}

                    <hr />

                    <h6 className="card-title mb-3 d-flex justify-content-between align-items-center">
                      Payments Details
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() => setShowPaymentModal(true)}
                      >
                        + Add Payment
                      </button>
                    </h6>

                    {/* payments table */}
                    <table className="table table-sm table-bordered mb-0">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Method</th>
                          <th>Amount</th>
                          <th>Remarks</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {!loadingPayments && paymentsList.length === 0 && (
                          <tr>
                            <td colSpan="5" className="text-center py-3">
                              No payments yet
                            </td>
                          </tr>
                        )}

                        {paymentsList.map((p, i) => (
                          <tr key={p.id ?? i}>
                            <td>{i + 1}</td>
                            <td>{p.mode ?? p.payment_method ?? "-"}</td>
                            <td>{Number(p.amount ?? p.amt ?? 0).toFixed(2)}</td>
                            <td>{p.remark ?? p.remarks ?? "-"}</td>
                            <td>
                              {formatDate(
                                p.created_at ?? p.date ?? p.timestamp
                              )}
                            </td>
                          </tr>
                        ))}
                        <tr>
                          <td colSpan="1" className="text-end">
                            <strong>Payments Total</strong>
                          </td>
                          <td colSpan="4">
                            <strong>{safeNum(paymentsTotal).toFixed(2)}</strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <hr />

                    <h6>Payment Summary</h6>
                    <table className="table table-sm table-bordered mb-0">
                      <tbody>
                        <tr>
                          <th>Net Payable Amt</th>
                          <td>
                            {(
                              safeNum(roomSubtotal) +
                              safeNum(taxTotal) +
                              safeNum(posTotal)
                            ).toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <th>Payments Collected</th>
                          <td>{safeNum(paymentsTotal).toFixed(2)}</td>
                        </tr>
                        <tr>
                          <th>Due Amount</th>
                          <td>{safeNum(dueAmount).toFixed(2)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            {/* Special Discount & Balance (kept simple) */}
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <h6 className="card-title">Special Discount</h6>
                </div>
                <div className="card-body">
                  <table className="table table-sm table-bordered mb-0">
                    <tbody>
                      <tr>
                        <th>Discount Type</th>
                        <td>
                          <select className="form-select">
                            <option defaultValue="selected">
                              Choose Discount
                            </option>
                            <option value="1">Friends</option>
                            <option value="2">Regular Customer</option>
                            <option value="3">MD Guest</option>
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <th>Discount Amt</th>
                        <td>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Discount Amt"
                          />
                        </td>
                      </tr>
                      <tr>
                        <th>Remarks</th>
                        <td>
                          <textarea className="form-control" />
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <hr />

                  <h6 className="card-title mb-3">Balance Details</h6>
                  <table className="table table-sm table-bordered mb-0">
                    <tbody>
                      <tr>
                        <th>Remain Amt</th>
                        <td>{safeNum(dueAmount).toFixed(2)}</td>
                      </tr>
                      <tr>
                        <th>Collected Amt</th>
                        <td>{safeNum(paymentsTotal).toFixed(2)}</td>
                      </tr>
                      <tr>
                        <th>Change Amt</th>
                        <td>
                          {Math.max(
                            0,
                            safeNum(paymentsTotal) -
                              (safeNum(roomSubtotal) +
                                safeNum(taxTotal) +
                                safeNum(posTotal))
                          ).toFixed(2)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            {/* Checkout Button */}
            <div className="col-sm-12 text-end">
              <button
                className="btn btn-primary"
                disabled={dueAmount > 0}
                onClick={handleCheckout}
              >
                Checkout
              </button>
              {dueAmount > 0 && (
                <small className="text-muted ms-2">
                  {" "}
                  (Due must be 0 to checkout)
                </small>
              )}
            </div>

            {/* Add Payment Modal */}
            {showPaymentModal && (
              <div
                className="modal fade show d-block"
                tabIndex="-1"
                style={{ background: "rgba(0,0,0,0.5)" }}
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Add Payment</h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setShowPaymentModal(false)}
                      ></button>
                    </div>

                    <div className="modal-body">
                      <div className="mb-3">
                        <label className="form-label">Payment Method</label>
                        <select
                          className="form-select"
                          value={paymentMethod}
                          onChange={(e) => setPaymentMethod(e.target.value)}
                        >
                          <option value="">Choose</option>
                          <option value="cash">Cash</option>
                          <option value="card">Card</option>
                          <option value="upi">UPI</option>
                          <option value="bank">Bank Transfer</option>
                        </select>
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Amount</label>
                        <input
                          type="number"
                          className="form-control"
                          value={paymentAmt}
                          onChange={(e) => setPaymentAmt(e.target.value)}
                          placeholder="Enter amount"
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Remarks (optional)</label>
                        <textarea
                          className="form-control"
                          value={paymentRemark}
                          onChange={(e) => setPaymentRemark(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="modal-footer">
                      <button
                        className="btn btn-secondary"
                        onClick={() => setShowPaymentModal(false)}
                        disabled={submittingPayment}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={submitPayment}
                        disabled={submittingPayment}
                      >
                        {submittingPayment ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default RoomCheckout;
